<div class="toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast toast-{{ toast.type }}">
      <div class="toast-content">
        <div class="toast-icon">
          @if (toast.type === 'success') {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99961 1.60004C14.6434 1.60004 18.3996 5.35622 18.3996 10C18.3996 14.6439 14.6434 18.4 9.99961 18.4C5.3558 18.4 1.59961 14.6439 1.59961 10C1.59961 5.35622 5.3558 1.60004 9.99961 1.60004ZM13.9949 5.99535C13.9299 5.99663 13.8662 6.01373 13.8093 6.04518C13.7524 6.07663 13.704 6.12147 13.6684 6.17582L9.58789 12.1907L6.67148 9.48441C6.63317 9.44755 6.5879 9.41869 6.53831 9.39953C6.48872 9.38036 6.43581 9.37128 6.38266 9.3728C6.32952 9.37432 6.27721 9.38642 6.2288 9.40839C6.18038 9.43036 6.13684 9.46176 6.1007 9.50075C6.06456 9.53974 6.03656 9.58555 6.01832 9.63549C6.00009 9.68543 5.992 9.73851 5.99452 9.79161C5.99703 9.84472 6.01011 9.89679 6.03299 9.94478C6.05586 9.99278 6.08807 10.0357 6.12773 10.0711L9.72617 13.4102L14.3309 6.62426C14.3731 6.56374 14.3978 6.49271 14.4021 6.41904C14.4065 6.34537 14.3904 6.27193 14.3557 6.20683C14.3209 6.14173 14.2688 6.08753 14.2051 6.0502C14.1415 6.01288 14.0687 5.99389 13.9949 5.99535Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99961 1.60004C14.6434 1.60004 18.3996 5.35622 18.3996 10C18.3996 14.6439 14.6434 18.4 9.99961 18.4C5.3558 18.4 1.59961 14.6439 1.59961 10C1.59961 5.35622 5.3558 1.60004 9.99961 1.60004ZM13.8093 6.04518C13.8662 6.01373 13.9299 5.99663 13.9949 5.99535C14.0687 5.99389 14.1415 6.01288 14.2051 6.0502C14.2688 6.08753 14.3209 6.14173 14.3557 6.20683C14.3904 6.27193 14.4065 6.34537 14.4021 6.41904C14.3978 6.49271 14.3731 6.56374 14.3309 6.62426L9.72617 13.4102L6.12773 10.0711C6.08807 10.0357 6.05586 9.99278 6.03299 9.94478C6.01011 9.89679 5.99703 9.84472 5.99452 9.79161C5.992 9.73851 6.00009 9.68543 6.01832 9.63549C6.03656 9.58555 6.06456 9.53974 6.1007 9.50075C6.13684 9.46176 6.18038 9.43036 6.2288 9.40839C6.27721 9.38642 6.32952 9.37432 6.38266 9.3728C6.43581 9.37128 6.48872 9.38036 6.53831 9.39953C6.5879 9.41869 6.63317 9.44755 6.67148 9.48441L9.58789 12.1907L13.6684 6.17582C13.704 6.12147 13.7524 6.07663 13.8093 6.04518Z"
                fill="currentColor"
              />
            </svg>
          } @else if (toast.type === 'danger') {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99961 2.28752L18.8996 17.7125H1.09961L9.99961 2.28752ZM9.53711 7.27502C9.45117 7.27502 9.39961 7.32658 9.39961 7.41252V13.2C9.39961 13.286 9.45117 13.35 9.53711 13.35H10.4621C10.548 13.35 10.5996 13.286 10.5996 13.2V7.41252C10.5996 7.32658 10.548 7.27502 10.4621 7.27502H9.53711ZM9.44961 14.5C9.39648 14.5203 9.37461 14.5735 9.37461 14.6375V15.6875C9.37461 15.7735 9.42617 15.825 9.51211 15.825H10.4871C10.573 15.825 10.6246 15.7735 10.6246 15.6875V14.6375C10.6246 14.5516 10.573 14.5 10.4871 14.5H9.51211C9.49023 14.5 9.4668 14.4938 9.44961 14.5Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99961 2.28752L18.8996 17.7125H1.09961L9.99961 2.28752ZM9.39961 7.41252C9.39961 7.32658 9.45117 7.27502 9.53711 7.27502H10.4621C10.548 7.27502 10.5996 7.32658 10.5996 7.41252V13.2C10.5996 13.286 10.548 13.35 10.4621 13.35H9.53711C9.45117 13.35 9.39961 13.286 9.39961 13.2V7.41252ZM9.37461 14.6375C9.37461 14.5735 9.39648 14.5203 9.44961 14.5C9.4668 14.4938 9.49023 14.5 9.51211 14.5H10.4871C10.573 14.5 10.6246 14.5516 10.6246 14.6375V15.6875C10.6246 15.7735 10.573 15.825 10.4871 15.825H9.51211C9.42617 15.825 9.37461 15.7735 9.37461 15.6875V14.6375Z"
                fill="currentColor"
              />
            </svg>
          } @else {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2ZM10.6667 14H9.33333V9.33333H10.6667V14ZM10 7.66667C9.448 7.66667 9 7.21867 9 6.66667C9 6.11467 9.448 5.66667 10 5.66667C10.552 5.66667 11 6.11467 11 6.66667C11 7.21867 10.552 7.66667 10 7.66667Z"
                fill="currentColor"
              />
            </svg>
          }
        </div>
        <div class="toast-message">{{ toast.message }}</div>
      </div>
      <button class="toast-close" (click)="remove(toast.id)">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.0877 2.51251L2.5127 3.08751L9.42519 10L2.5127 16.9125L3.0877 17.4875L10.0002 10.575L16.9127 17.4875L17.4877 16.9125L10.5752 10L17.4877 3.08751L16.9127 2.51251L10.0002 9.42501L3.0877 2.51251Z"
            fill="black"
          />
        </svg>
      </button>
    </div>
  }
</div>
